import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { AssociatedDocumentSignedEditionViewStore } from "../../store";
import { AssociatedDocumentSignedEditionView } from "./AssociatedDocumentSignedEditionView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type AssociatedDocumentSignedEditionDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const AssociatedDocumentSignedEditionDrawerContent: React.FC<AssociatedDocumentSignedEditionDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new AssociatedDocumentSignedEditionViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <AssociatedDocumentSignedEditionView
        associatedDocumentSignedEditionViewStore={viewStore}
      />
    );
  });
